import React from 'react';
import { Grid, Header, Button, Segment, Label } from 'semantic-ui-react';

const TriviaCard = props => (
    <Segment raised secondary>
        <Label size="mini" color='black' content={`Question ${props.Answered + 1}/${props.Total}`} />
        <Header size="large" key={props.Active.questionText} content={props.Active.questionText} />
        <Grid stretched doubling stackable columns={2}>
            {
                props.Active.possibleAnswers.map(answer => 
                    <Grid.Column key={answer.title}>
                        <Button fluid color="google plus" content={answer.title} onClick={() => props.SubmitAnswer(answer)} />
                    </Grid.Column>
                )
            }
        </Grid>
    </Segment>
)

export default TriviaCard;
